<div class="modal-header">
  <portal-error-header
    [dismissible]="false"
    [errors]="errors"
    [hideCollapse]="true"
    [hideWarningIcon]="true"
    [title]="title != null ? titleTemplate : undefined"
    className="modal-title h4 text-danger d-flex"
  ></portal-error-header>

  <ng-template #titleTemplate>
    @if (titleIsTranslatable) {
      <div [innerHTML]="$any(title) | portalTranslate"></div>
    } @else {
      <ng-container [ngTemplateOutlet]="$any(title)"></ng-container>
    }
  </ng-template>

  <button class="btn-close" (click)="dismiss()" aria-label="Close" portalAutofocus type="button"></button>
</div>

<portal-modal-body class="px-0">
  @if (description != null) {
    @if (descriptionIsTranslatable) {
      <div [innerHTML]="$any(description) | portalTranslate"></div>
    } @else {
      <ng-template
        [ngTemplateOutlet]="$any(description)"
        [ngTemplateOutletContext]="{ errors: errors }"
      ></ng-template>
    }
  }

  <portal-error-body [errors]="errors"></portal-error-body>
</portal-modal-body>

<portal-modal-footer [closeOnly]="true" (onCancel)="dismiss()"></portal-modal-footer>
